import { Container } from "@material-ui/core";
import { useCallback, useMemo } from "react";

import { ContentSection } from "../../application/ContentSection";
import { ListSection } from "../../components/list-section/ListSection";
import { GardeningTaskGardenerViewDocument } from "../../gardening-task/gardener-view/gardening-task-gardener-view.model";

interface PastCustomersTabProps {
    gardeningTasks: GardeningTaskGardenerViewDocument[];
    goToCustomer: (customerId: string) => void;
}

export const PastCustomersTab = (props: PastCustomersTabProps) => {
    const { gardeningTasks, goToCustomer } = props;

    const sortedGardeningTasks = useMemo(() => {
        return gardeningTasks.sort((a, b) => {
            if ( !a.customer.name && b.customer.name ) return -1;
            if ( a.customer.name && !b.customer.name ) return 1;
            if ( !a.customer.name && !b.customer.name ) return 0;

            if ( a.customer.name && b.customer.name ) {
                if ( a.customer.name < b.customer.name ) return -1;
                if ( a.customer.name > b.customer.name ) return 1;
            }

            return 0;
        });
    }, [gardeningTasks]);

    const listItems = useMemo(() => {
        return sortedGardeningTasks.map(gardeningTask => ({
            heading: gardeningTask.customer.name ?? "Kundens navn er ikke længere tilgængeligt",
            subheading: gardeningTask.customer.address ? `${gardeningTask.customer.address.street}, ${gardeningTask.customer.address.zipCode}` : "Adresse er ikke længere tilgængelig",
        }));
    }, [sortedGardeningTasks]);

    const goToCustomerUsingIndex = useCallback((index: number) => {
        const gardeningTask = sortedGardeningTasks[index];
        goToCustomer(gardeningTask.customer.id);
    }, [sortedGardeningTasks, goToCustomer]);
    
    return (
        <ContentSection>
            <Container maxWidth="sm" disableGutters>

                <ListSection
                    title="Tidligere kunder"
                    placeholder="Du har ingen tidligere kunder"
                    items={listItems}
                    onClick={goToCustomerUsingIndex}
                />

            </Container>
        </ContentSection>
    );
};
